export const DELETE_WARNING = "Are you sure? This action can't be undone";

export const UNSAVED_CHANGES_WARNING =
  'You have unsaved changes on this page. Continue anyway?';

export const BULK_RUNNING_WARNING =
  'You have a bulk process running. Do you want to cancel?';

export const VISIBLE_TO_CUSTOMERS_MESSAGE = 'Visible to customers in checkout';
